<ng-container *ngFor="let unit of units">
  <div class="tech-tab-add-unit" *ngIf="!unit.active && unit.canAdd">
    <button mat-icon-button type="button" [disabled]="isReadOnly()" (click)="onAdd(unit)">
      <mat-icon>add</mat-icon>
    </button>
  </div>
  <div class="tech-tab-unit" *ngIf="unit.active">
    <h4>
      {{ unit.label }}
      <button
        *ngIf="unit.canDelete"
        mat-icon-button
        type="button"
        [disabled]="isReadOnly()"
        (click)="onDelete(unit)"
      >
        <mat-icon>delete</mat-icon>
      </button>
    </h4>

    <digires-list-input [readOnlyState]="readOnlyState"
                        [finModel]="financialModelReadManager"
                        [formGroup]="formGroup"
                        [initialData]="initialData"
                        [required]="projectCreation"
                        [formCtrlPath]="[unit.id]"
                        formCtrlName="subTechnology"
                        [items]="allSubTechnologies"
                        [itemToLabel]="subTechnologyToLabel"
                        placeholder="Sub-Technology"
                        tooltip="Identifies the sub-technology for Type {{unit?.id | lastLetter}} of the proposed
                        Solar installation, available options are: Ground Mounted-PV, Rooftop-PV, Floating-PV, Agri-PV, Moor-PV."
                        error="Mandatory: Please select a value"
    ></digires-list-input>

    <digires-num-input [readOnlyState]="readOnlyState"
                       [finModel]="financialModelReadManager"
                       [formGroup]="formGroup"
                       [initialData]="initialData"
                       [formCtrlPath]="[unit.id]"
                       formCtrlName="areaSize"
                       placeholder="Site Area (ha)"
                       error="Please enter a positive number"
                       tooltip="Identifies the site area for Type {{unit?.id | lastLetter}} of the proposed solar installation, as measured in hectares (ha)."
    ></digires-num-input>

    <digires-text-input [readOnlyState]="readOnlyState"
                        [finModel]="financialModelReadManager"
                        [formGroup]="formGroup"
                        [initialData]="initialData"
                        [formCtrlPath]="[unit.id]"
                        formCtrlName="description"
                        placeholder="Site Description"
                        tooltip="Identifies the site description (e.g. agricultural land) for Type {{unit?.id | lastLetter}} of the proposed Solar installation."
    ></digires-text-input>

    <digires-list-input [readOnlyState]="readOnlyState"
                        [finModel]="financialModelReadManager"
                        [formGroup]="formGroup"
                        [initialData]="initialData"
                        [formCtrlPath]="[unit.id]"
                        formCtrlName="moduleType"
                        [items]="allModuleTypes"
                        [itemToLabel]="moduleTypeToLabel"
                        placeholder="Module Type"
                        tooltip="The type of Solar Module technology that it is proposed to install in the project: PV, CSP, Monocrystalline, Polycrystalline, Thin film."
    ></digires-list-input>

    <digires-list-input [readOnlyState]="readOnlyState"
                        [finModel]="financialModelReadManager"
                        [formGroup]="formGroup"
                        [initialData]="initialData"
                        [formCtrlPath]="[unit.id]"
                        formCtrlName="facialType"
                        [items]="allFacialTypes"
                        [itemToLabel]="facialTypeToLabel"
                        placeholder="Module Facial Type"
                        tooltip="Identification of what face of the Solar Module can produce electricity when illuminated.
                        Monofacial solar cells can only produce electricity when illuminated on their front face.
                        Bifacial solar cells can produce electricity when illuminated on both their front and rear faces: Monofacial, Bifacial
                        (Read from the finanical model V3.5)."
    ></digires-list-input>

    <digires-list-input [readOnlyState]="readOnlyState"
                        [finModel]="financialModelReadManager"
                        [formGroup]="formGroup"
                        [initialData]="initialData"
                        [formCtrlPath]="[unit.id]"
                        formCtrlName="mountingSystem"
                        [items]="allMountingSystems"
                        [itemToLabel]="mountingSystemToLabel"
                        placeholder="Mounting System"
                        tooltip="The type of mounting system that is used for the mounting of the Solar Modules:
                        Fixed Tilt South, Fixed Tilt East-West, Vertical North-South, Floating South Tilt,
                        Floating East-West Tilt, PEG East/West, PEG South, Agri PV (high), Agri PV (low), Tracker
                        (Read from the financial model.)"
    ></digires-list-input>

    <digires-num-input [readOnlyState]="readOnlyState"
                       [finModel]="financialModelReadManager"
                       [formGroup]="formGroup"
                       [initialData]="initialData"
                       [formCtrlPath]="[unit.id]"
                       formCtrlName="count"
                       placeholder="Number of Modules"
                       error="Please enter a positive number"
                       tooltip="The number of Type {{unit?.id | lastLetter}} Solar Modules that it is proposed to install in this Project as set out in the preferred scenario in the financial model."
    ></digires-num-input>

    <digires-num-input [readOnlyState]="readOnlyState"
                       [finModel]="financialModelReadManager"
                       [formGroup]="formGroup"
                       [initialData]="initialData"
                       [formCtrlPath]="[unit.id]"
                       formCtrlName="capacity"
                       placeholder="Module Capacity (Wp)"
                       error="Please enter a positive number"
                       tooltip="The capacity (in Watt Peak (Wp)) for each individual Module (Read from the finanical model V3.5)."
    ></digires-num-input>

    <digires-num-input [formGroup]="formGroup"
                       [finModel]="financialModelReadManager"
                       [initialData]="initialData"
                       [formCtrlPath]="[unit.id]"
                       formCtrlName="totalCapacity"
                       [readOnly]="true"
                       readOnlyReason="{{calculatedReadOnlyReason}}"
                       placeholder="Total Capacity per Module Type (MWp)"
                       tooltip="The total installed capacity of this Type of Solar Module that is calculated by
                       multiplying the installed capacity of this model of Solar Module by the number of modules of
                       this Type that it is proposed to install in this Project as set out in the preferred scenario
                       in the financial model. This relates to the total Solar capacity of the project as a whole.
                       Notes: Installed Capacity expressed in megawatts peak (MWp) in D.C. (direct current.) As the
                       project evolves through the development process the installed capacity may fluctuate if the
                       Solar Module type is changed as the project matures and more information is available to the
                       project team, including new models coming to market."
    ></digires-num-input>

    <digires-text-input [readOnlyState]="readOnlyState"
                        [finModel]="financialModelReadManager"
                        [formGroup]="formGroup"
                        [initialData]="initialData"
                        [formCtrlPath]="[unit.id]"
                        formCtrlName="manufacturer"
                        placeholder="Module Manufacturer"
                        tooltip="Identifies the name of the manufacturer of the modules for Type {{unit?.id | lastLetter}} of the proposed Solar installation."
    ></digires-text-input>

    <digires-text-input [readOnlyState]="readOnlyState"
                        [finModel]="financialModelReadManager"
                        [formGroup]="formGroup"
                        [initialData]="initialData"
                        [formCtrlPath]="[unit.id]"
                        formCtrlName="inverterModel"
                        placeholder="Inverter Model"
                        tooltip="Identifies the name of the model of the Inverter for Type {{unit?.id | lastLetter}} of the proposed Solar installation."
    ></digires-text-input>

    <digires-num-input [readOnlyState]="readOnlyState"
                       [finModel]="financialModelReadManager"
                       [formGroup]="formGroup"
                       [initialData]="initialData"
                       [formCtrlPath]="[unit.id]"
                       formCtrlName="inverterCount"
                       placeholder="Number of Inverters"
                       error="Please enter a positive number"
                       tooltip="Identifies the number of Inverters for Type {{unit?.id | lastLetter}} of the proposed Solar installation."
    ></digires-num-input>

    <digires-text-input [readOnlyState]="readOnlyState"
                        [finModel]="financialModelReadManager"
                        [formGroup]="formGroup"
                        [initialData]="initialData"
                        [formCtrlPath]="[unit.id]"
                        formCtrlName="inverterType"
                        placeholder="Inverter Type"
                        tooltip="Identifies the Type of the Inverters for Type {{unit?.id | lastLetter }} of the proposed Solar installation."
    ></digires-text-input>
  </div>
</ng-container>
